import { render, staticRenderFns } from "./MemberHome.vue?vue&type=template&id=2fcf53d1&"
import script from "./MemberHome.vue?vue&type=script&lang=js&"
export * from "./MemberHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports